// A row of suggestion chips under the composer (stage chips of a Penyedia
// paket, a guest's workflow chips). A chip fills the composer; nothing is
// sent until the user sends it.
import type { SuggestionChip } from "../project/stage-chips";
import { Glyph } from "../ui/icons";

export interface SuggestionChipsProps {
  chips: SuggestionChip[];
  onPick: (chip: SuggestionChip) => void;
  disabled?: boolean;
  /** The group's accessible name. */
  label?: string;
  /** In a thread: one quiet row under the docked composer. */
  docked?: boolean;
}

export function SuggestionChips({ chips, onPick, disabled = false, label = "Saran pertanyaan", docked = false }: SuggestionChipsProps) {
  if (chips.length === 0) return null;
  return (
    <div className="chat-chips chat-suggestions" data-docked={docked ? "" : undefined} role="group" aria-label={label}>
      {chips.map((c) => (
        <button key={c.label} type="button" className="chip chat-chip" disabled={disabled} title={c.prompt} onClick={() => onPick(c)}>
          <Glyph name="magicStar" size={16} />
          <span>{c.label}</span>
        </button>
      ))}
    </div>
  );
}
